import styled from 'styled-components';

// Example of a general purpose Box layout component
export const ButtonImage = styled.img`
    vertical-align: middle;
    display: inline-block;
    border: 0;
    padding-right: 5px;
`;

export const IconImage = styled.img`
    top: 50%;
    position: absolute;
    margin-top: -10px;
    left: 50%;
    margin-left: -10px;
`;



// WEBPACK FOOTER //
// ./src/styledSystem/Image.js